import React, { useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { AccordionContext, useAccordionButton } from 'react-bootstrap';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';
import Sprite from 'core/tools/Sprite';

// STYLES
import styles from './listCardToggle.module.scss';

// MAIN COMPONENT
const ListCardToggle = ({ eventKey, onToggle }) => {
  const currentEventKey = useContext(AccordionContext);

  const handleClick = useAccordionButton(eventKey, () => onToggle && onToggle(eventKey));

  const isActive = currentEventKey === eventKey;

  return (
    <Button.Link className={clsx(styles.toggle, 'ms-3', isActive && 'text-primary')} onClick={handleClick}>
      <Sprite use={isActive ? 'chevron-up' : 'chevron-down'} />
    </Button.Link>
  );
};

// EXPORT
export default ListCardToggle;
